import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

const searchBoxRoot = ReactDOM.createRoot(
	document.getElementById("root-search-box") as HTMLElement,
);
searchBoxRoot.render(
	<BrowserRouter>
		<App />
	</BrowserRouter>,
);
